import classNames from 'classnames/bind';
import styles from './AboutPage.module.scss';
import TitleComp2 from '~/component/TitleComp2';

const cx = classNames.bind(styles);

function AboutPage() {
  return (
    <div className={cx('wrapper')}>
      <TitleComp2 className={cx('title')}>Giới Thiệu</TitleComp2>
      <p>
        Chào mừng bạn đến với blog cá nhân của Ngô Gia Quyến – Fullstack Developer. Đây là nơi tôi chia sẻ các bài viết
        về lập trình, dự án thực tế và kiến thức công nghệ mới nhất.
      </p>
      <p>
        Website bao gồm các mục: bài đăng, kiến thức về lập trình, dự án cá nhân, danh sách nhạc, CV, ghi chú, chat, và
        nhiều tính năng thú vị khác giúp bạn khám phá và học hỏi.
      </p>

      <h3 className={cx('subtitle')}>Thông tin liên hệ</h3>
      <ul className={cx('list')}>
        <li>
          Email: <a href="mailto:ngogiaquyendhtn223@gmail.com">ngogiaquyendhtn223@gmail.com</a>
        </li>
        <li>
          Điện thoại: <a href="tel:0356197132">0356 197 132</a>
        </li>
        <li>
          GitHub:{' '}
          <a href="https://github.com/ngogiaquyen" target="_blank" rel="noopener noreferrer">
            github.com/ngogiaquyen
          </a>
        </li>
      </ul>

      <h3 className={cx('subtitle')}>Công nghệ sử dụng</h3>
      <p>Website được xây dựng bằng các công nghệ:</p>
      <ul className={cx('list')}>
        <ul>
          <li>Frontend: HTML, CSS, JavaScript, ReactJS</li>
          <li>
            Backend: NodeJS (ExpressJS), PHP, <del>Django (dừng hoạt động)</del>
          </li>
          <li>
            Cơ sở dữ liệu: MySQL, <del>MongoDB (dừng hoạt động)</del>
          </li>
        </ul>
        <li>
          Triển khai: Hosting{' '}
          <a target="_blank" href="https://tenten.vn/vi">
            tenten.vn
          </a>
          , Render{' '}
          <a target="_blank" href="https://render.com/">
            render.com
          </a>
        </li>
      </ul>
      <h3 className={cx('subtitle')}>Ngày tạo blog</h3>
      <p>
        Blog được tạo vào ngày 28/02/2025, cập nhật ngày 17/10/2025 và liên tục được cập nhật với những nội dung mới.
      </p>
    </div>
  );
}

export default AboutPage;
